<div class="empty-list-container">
  <div class="icon-wrapper">
    <img class="folder-icon" src="assets/icons/icon-folder-active.svg" alt="inventory-icon"/>
  </div>
  <div class="empty-list-header">{{header}}</div>
  <div class="empty-list-description">
    {{message}}
  </div>
</div>
